import { CLASSES, EQUIPMENT, StudentServicePath } from "utils/constants";
import permissions from "app/permissions";
import UpdateEquipment from "./Edit";

export const resources = {
  name: StudentServicePath + CLASSES + "/" + EQUIPMENT,
  title: "Налично техническо оборудване",
  edit: <UpdateEquipment />,
  editPermission: permissions.canPreviewUsedEquipment,
  isMenu: false,
};
